import { InviteChannel } from '../match/invite-channel';
import { CommunicationMethodMagicLink } from './communication-method-magic-link.enum';
import { EnumObject } from './enum-object';
import { INVITE_SOURCE_BY_COMMUNICATION_METHOD, InviteOpenAcceptSource } from './invite-open-accept-source.enum';

export const TrackingChannel = {
  ...InviteChannel,
  Email: 'email',
  Rcs: 'rcs',
} as const;

export type TrackingChannel = EnumObject<typeof TrackingChannel>;

const INVITE_SOURCE_TO_TRACKING_CHANNEL: Partial<Record<InviteOpenAcceptSource, TrackingChannel>> = {
  [InviteOpenAcceptSource.EmailInviteLink]: TrackingChannel.Email,
  [InviteOpenAcceptSource.SmsInviteLink]: TrackingChannel.Sms,
  [InviteOpenAcceptSource.WhatsappInviteLink]: TrackingChannel.WhatsApp,
  [InviteOpenAcceptSource.Rcs]: TrackingChannel.Rcs,
};

export const getTrackingChannelFromInviteSource = (inviteChannel?: InviteOpenAcceptSource | null): TrackingChannel | null =>
  inviteChannel ? (INVITE_SOURCE_TO_TRACKING_CHANNEL[inviteChannel] ?? null) : null;

export const getTrackingChannelFromCommunicationMethod = (method?: CommunicationMethodMagicLink | null): TrackingChannel | null =>
  method ? getTrackingChannelFromInviteSource(INVITE_SOURCE_BY_COMMUNICATION_METHOD[method]) : null;
